export default __webpack_public_path__ + "static/media/image_main.3753687a.png";